import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { MAddUpdateCartModule } from 'src/app/pages/product-detail-updated/product-detail-updated.module';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { LoginPopupComponent } from '../login-popup/login-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-box',
  templateUrl: './product-box.component.html',
  styleUrls: ['./product-box.component.scss']
})
export class ProductBoxComponent {
  @Input() product: any
  @Input() mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule()
  @Input() mAddUpdateCartModuleResponse: any
  @Input() mWishlistData: any
  @Input() productType?: any
  @Input() color?: any
  @Output() addToCartBuyNow = new EventEmitter();
  @Output() onUserLogin = new EventEmitter();
  message:any;
  type: any;
  discountApplied: number = 0;
  showToast: boolean = false;
  constructor(private modalService: NgbModal, private router: Router, 
    private wsShopAllService: WsShopallService, 
    private _commonBehaviorChangeService: CommonBehaviorChangeService, private toast: ToastrService) {

  }
  ngOnInit() {
  }

  getProductSize(product: any) {
    if (product && product.extras && product.extras.length > 0) {
      var size = product.extras.filter((p: any) => p.id == product.id)
      return size[0].size
    } else {
      return product.size;
    }
  }

  showProduct(product: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g,'_')])
  }


  async addToCartCommon(product: any, productType?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
   
    if (this.type == 'cart') {
      this.mAddUpdateCartModule.iswishlistitem = false;
      product.isLoading = true;
      if(!product.cartQty){
        product.cartQty = 1
      }
    } else {
      this.mAddUpdateCartModule.iswishlistitem = true;
    }
    if (this.type == "cart") {
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
      if (cart > -1) {
        this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
      } else {
        this.mAddUpdateCartModule.qty = 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.mAddUpdateCartModule = new MAddUpdateCartModule();
          this._commonBehaviorChangeService.addCart(true);
          product.isLoading = false;
          this._commonBehaviorChangeService.getToast('Product added to cart successfully')
        } else {
          console.log("something went wrong")
        }
      })
    } else {
      if (productType == 'wishlist' || this.productType == 'wishlist') {
        const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
        if (wishlist > -1) {
          this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
        }
        this.mAddUpdateCartModule.qty = 0;
      } else {
        this.mAddUpdateCartModule.iswishlistitem = product.like ? false : true;
        if (product.like) {
          const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
          if (wishlist > -1) {
            this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
          }
        }
        this.mAddUpdateCartModule.qty = product.like ? 0 : 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          if (!product.productdetail) {
            if (product.like || this.productType == 'wishlist') {
              delete product.like;
              this.message = 'Wishlist removed successfully';             
            } else {
              product.like = this.mAddUpdateCartModule.iswishlistitem;
              this.message = 'Wishlist added successfully';
            }
            this._commonBehaviorChangeService.getToast(this.message)
          } else {
            var productIndex = this.mWishlistData.findIndex((p: any) => p.product_id == product.productdetail.id)
            if (productIndex > -1) {
              this.mWishlistData.splice(productIndex, 1)
            }
          }
          this._commonBehaviorChangeService.addWishlist(true)
        } else {
          console.log("something went wrong")
        }
      })
    }
  }

  async addtoCart(product: any, val: any) {
    if (this.router.url.indexOf('/checkout-new/buynow') == -1 && this.router.url.indexOf('/checkout-new-mob/buynow') == -1) {
    this.type = val;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.mAddUpdateCartModule = new MAddUpdateCartModule();
      this.addToCartCommon(product, this.type)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.addToCartCommon(product, this.type)
          this.onUserLogin.emit();
        }
      })
    }
  }else{
    const productDetail = {
      qty: 1,
      productId: product.id,
      product_id: product.id,
      price: product.your_price ,
      productdetail : product
    }
    this.addToCartBuyNow.emit(productDetail)
  }
  }

  async addCartItem(product: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    product.isLoading = true;
    if (!product.productdetail) {
      product['cartQty'] = product['cartQty'] + 1
      this.mAddUpdateCartModule.qty = product['cartQty']
    } else {
      product['productdetail']['cartQty'] = product['productdetail']['cartQty'] + 1
      this.mAddUpdateCartModule.qty = product['productdetail']['cartQty']
    }
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
        product.isLoading = false;
       
        this._commonBehaviorChangeService.getToast('Product added to cart successfully')
      } else {
        console.log("something went wrong")
      }
    })
  }

  async removeCartItem(product: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    this.mAddUpdateCartModule.iswishlistitem = false;
    product.isLoading = true;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    if (product.cartQty > 0) {
      if (!product.productdetail) {
        product['cartQty'] = product['cartQty'] - 1
        this.mAddUpdateCartModule.qty = product['cartQty']
      } else {
        product['productdetail']['cartQty'] = product['productdetail']['cartQty'] - 1
        this.mAddUpdateCartModule.qty = product['productdetail']['cartQty']
      }
    } else {
      this.mAddUpdateCartModule.qty = 0;
      if (!product.productdetail) {
        delete product['cartQty']
      } else {
        delete product['productdetail']['cartQty']
      }
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
        product.isLoading = false;
        this._commonBehaviorChangeService.getToast('Product removed from cart successfully')
      } else {
        console.log("something went wrong")
      }
    })
  }

  getDiscountShow(val: any) {
    if (val.discountList.length > 0) {
      if (val.discountList[0].amount) {
        return '₹' + val.discountList[0].amount + 'OFF'
      } else {
        return val.discountList[0].percentage + '% OFF'
      }
    } else {
      return ;
    }
  }

  getProductPrice(val: any) {
    if (val.discountList.length > 0) {
      if (val.discountList[0].amount < 1) {
        this.discountApplied = val.your_price * val.discountList[0].percentage / 100;
        if (this.discountApplied > val.your_price) {
          this.discountApplied = val.your_price;
        }
        if (this.discountApplied > val.discountList[0].max_amount && val.discountList[0].max_amount > 0) {
          if (val.discountList[0].max_amount > val.your_price) {
            this.discountApplied = val.your_price;
          } else {
            this.discountApplied = val.discountList[0].max_amount;
          }
        }
      }

      if (val.discountList[0].amount > 0) {
        if (val.your_price > val.discountList[0].amount) {
          this.discountApplied = val.discountList[0].amount;
        } else {
          this.discountApplied = val.your_price;
        }
      }
      return Math.round((val.your_price - this.discountApplied))
    } else {
      return Math.round(val.your_price)
    }
  }
}
